// extracted by mini-css-extract-plugin
export default {"unclaimedLearnMoreModal":"unclaimedLearnMoreModal__YzAyN","heading":"heading__MDFlZ","favoriteButton":"favoriteButton__ZjcwY"};